export default async function detectWebGLContext() {
  return await new Promise((resolve, reject) => {
    const gl = getGLContext();
    const isSupported = gl && gl instanceof WebGLRenderingContext;
    return isSupported
      ? resolve(isSupported)
      : reject({ message: 'Your browser does not WebGL.' });
  });
}

export function getMaxTextureSize() {
  const gl = getGLContext();
  if (!gl) {
    console.error('webgl context not found');
    return null;
  }
  const maxTextureSize = gl.getParameter(gl.MAX_TEXTURE_SIZE);
  // maxTextureSize is the max diameter in bytes. Dividing by 4 assuming that 32bit is the max.
  // 32 bit has 4 bytes per pixel
  return maxTextureSize / 4;
}

function getGLContext() {
  const canvas = document.createElement('canvas');
  return canvas.getContext('webgl') || canvas.getContext('experimental-webgl');
}
